import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7991ffaf&scoped=true&"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=7991ffaf&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7991ffaf",
  null
  
)

export default component.exports